exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footerWrap_54eas {\n    font-size: 16px;\n}\n\n.footerWrap_54eas p {\n    margin: 0;\n}\n\n.footerDescription_1oY1D {\n    font-style: italic;\n    margin-right: 50px;\n}\n\n.footerLeft_2ZBHE {\n    display: inline-block;\n    font-size: 12px;\n    margin-top: 10px;\n    margin-bottom: 5px;\n    position: relative;\n    min-height: 100%;\n}\n\n.footerRight_1lVAk {\n    width: 25%;\n    display: inline-block;\n    text-align: right;\n    font-size: 12px;\n}\n\n.footerBold_3nwsH {\n    font-weight: bold;\n    padding-left: 3px;\n    font-size: 13px;\n}\n", ""]);

// exports
exports.locals = {
	"footerWrap": "footerWrap_54eas",
	"footerDescription": "footerDescription_1oY1D",
	"footerLeft": "footerLeft_2ZBHE",
	"footerRight": "footerRight_1lVAk",
	"footerBold": "footerBold_3nwsH"
};